export default "__VITE_ASSET__6d666ee5__"